// 일괄 작업요청 [공종별 미리보기](941 S16-8, 시나리오 S11 CASE_8) 순수 로직 — 시험: bulkPreview.logic.test.ts.
// 알림톡 본문은 서버가 실제 발송과 같은 규칙(Hermes 렌더)으로 만든다 — 화면은 문구를 직접 조립하지 않는다.

export const BULK_PREVIEW_MESSAGE = {
  button: '공종별 미리보기',
  title: '공종별 미리보기',
  hint: '선택한 공종마다 실제로 나가는 알림톡이에요',
  loading: '미리보기를 불러오는 중이에요',
  loadError: '미리보기를 불러오지 못했어요',
  retry: '다시 불러오기',
  noContent: '보낼 내용이 없어 이 공종은 발송되지 않아요',
  renderFailed: '알림톡 문구를 만들지 못했어요 · 잠시 후 다시 시도해 주세요',
  close: '닫기',
} as const;

/** 탭 이름을 만드는 데 필요한 공종 행 정보 */
export interface BulkPreviewRow {
  siteName: string | null;
  workTypeName: string;
}

/**
 * 탭 이름 — 현장이 하나면 공종명, 여러 현장이면 '현장 · 공종'. 같은 이름이 겹치면 번호를 붙여 구분한다(예: 타일 1 · 타일 2).
 * 입력 순서 그대로 같은 길이의 배열을 돌려준다.
 */
export function bulkPreviewTabLabels(rows: readonly BulkPreviewRow[]): string[] {
  const multiSite = new Set(rows.map((r) => r.siteName ?? '')).size > 1;
  const base = rows.map((r) => (multiSite && r.siteName ? `${r.siteName} · ${r.workTypeName}` : r.workTypeName));
  const total = new Map<string, number>();
  base.forEach((label) => total.set(label, (total.get(label) ?? 0) + 1));
  const seen = new Map<string, number>();
  return base.map((label) => {
    if ((total.get(label) ?? 0) < 2) return label;
    const n = (seen.get(label) ?? 0) + 1;
    seen.set(label, n);
    return `${label} ${n}`;
  });
}

/** 본문이 없는 탭에 보여 줄 안내 — 보낼 내용이 없어서인지(발송 안 됨), 문구 생성이 실패해서인지 가른다. */
export function bulkPreviewEmptyText(hasContent: boolean): string {
  return hasContent ? BULK_PREVIEW_MESSAGE.renderFailed : BULK_PREVIEW_MESSAGE.noContent;
}
